import { createSelector } from "@reduxjs/toolkit";
import { StateType } from "../../core/redux/store";


const bestPlayerState = ({ bestPlayer }: StateType) => bestPlayer;

export const bestPlayerLoadingSelector = createSelector(bestPlayerState, ({ isLoading }) => isLoading);
export const bestPlayerCountSelector = createSelector(bestPlayerState, ({ count }) => count);
export const bestPlayerListSelector = createSelector(bestPlayerState, ({ items }) => items);
export const bestPlayerSelector = createSelector(bestPlayerState, ({ entity }) => entity);
export const bestPlayersSelector = createSelector(bestPlayerState, ({ players }) => players);
export const bestPlayersIdsSelector = createSelector(bestPlayerState, ({ playerIds }) => playerIds);
export const votingMatchesSelector = createSelector(bestPlayerState, ({ matches }) => matches);
export const seasonsSelector = createSelector(bestPlayerState, ({ seasons }) => seasons);
export const teamsSelector = createSelector(bestPlayerState, ({ teams }) => teams);
